module.exports = __webpack_public_path__ + "img/hanfu.1bf1987f.jpg";